import React, { Suspense } from 'react';
import styled from 'styled-components';

import type { UniverseReference } from '@front/common/src/types/commons';
import { toRem } from '@front/common/src/utils/styles';

import { translate } from '@front/i18n';

import LoadingSpinner from '@front/web-ui/src/components/loading-spinner/loading-spinner';

export const FormTunnelChildcare = React.lazy(() => import('../form-tunnel-childcare/form-tunnel-childcare'));
export const FormTunnelWellness = React.lazy(() => import('../form-tunnel-wellness/form-tunnel-wellness'));
export const FormTunnelCleaning = React.lazy(() => import('../form-tunnel-cleaning/form-tunnel-cleaning'));

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Content = styled.div`
  width: 100%;
`;

const LeavingAppWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${toRem(100)};
`;

const t = translate('components.form_container');

const getTunnelForUniverse = (isSignedIn: boolean, universe: UniverseReference) => {
  switch (universe) {
    case 'childcare':
      return <FormTunnelChildcare isSignedIn={isSignedIn} />;
    case 'cleaning':
      return <FormTunnelCleaning isSignedIn={isSignedIn} />;
    default:
      return <FormTunnelWellness isSignedIn={isSignedIn} />;
  }
};

export type FormContainerProps = {
  universe: UniverseReference;
  isSignedIn: boolean;
  isLeavingApp: boolean;
};

const FormContainer = ({ universe, isSignedIn, isLeavingApp }: FormContainerProps) => (
  <section>
    <Suspense>
      <Container>
        <Content>
          {isLeavingApp ? (
            <LeavingAppWrapper>
              <LoadingSpinner size='lg' title={t('.leaving_app')} />
            </LeavingAppWrapper>
          ) : (
            getTunnelForUniverse(isSignedIn, universe)
          )}
        </Content>
      </Container>
    </Suspense>
  </section>
);

export default FormContainer;
